// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gzrsQ","title":"styles_title__zradd","button":"styles_button__+qYU0"};